import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Menu, X } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_1372e601-3756-4090-a4b3-dfd0e81eaf5a/artifacts/djc1777r_Muscle%20Mineral%20Logo.png";
const XTREME_LOGO_URL = "https://customer-assets.emergentagent.com/job_1372e601-3756-4090-a4b3-dfd0e81eaf5a/artifacts/mlrns2tl_image.png";
const BUY_URL = "https://xtremenutrition.co.za/product/muscle-mineral-creatine-monohydrate-1kg/";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { label: "Product", href: "#product" },
    { label: "Benefits", href: "#benefits" },
    { label: "Nutrition", href: "#nutrition" },
    { label: "About", href: "#about" },
  ];

  return (
    <motion.header
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "glass border-b border-white/10" : "bg-transparent"
      }`}
      data-testid="header"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-24">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a href="/" className="flex items-center" data-testid="logo-link">
            <img 
              src={LOGO_URL} 
              alt="Muscle Mineral" 
              className="h-10 md:h-12 w-auto invert"
            />
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8" data-testid="desktop-nav">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="font-mono text-sm uppercase tracking-widest text-[#A3A3A3] hover:text-white transition-colors duration-300"
                data-testid={`nav-${link.label.toLowerCase()}`}
              >
                {link.label}
              </a>
            ))}
          </nav>

          {/* Buy Now Button with Xtreme Nutrition */}
          <div className="flex items-center gap-4">
            <a
              href={BUY_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="hidden sm:flex items-center gap-3 bg-[#3A3A3A] hover:bg-[#4A4A4A] text-white font-bold uppercase tracking-wider px-4 py-2 transition-all duration-300 hover:scale-105"
              style={{ fontFamily: 'Oswald, sans-serif' }}
              data-testid="buy-now-header-btn"
            >
              <span className="text-sm">Buy at</span>
              <img 
                src={XTREME_LOGO_URL} 
                alt="Xtreme Nutrition" 
                className="h-8 w-auto"
              />
            </a>

            {/* Mobile Menu Toggle */}
            <button
              className="md:hidden text-white p-2"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              data-testid="mobile-menu-toggle"
            >
              {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          className="md:hidden glass border-t border-white/10"
          data-testid="mobile-menu"
        >
          <nav className="flex flex-col py-6 px-6">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                onClick={() => setMobileMenuOpen(false)}
                className="font-mono text-sm uppercase tracking-widest text-[#A3A3A3] hover:text-white py-3 border-b border-white/10 last:border-none"
                data-testid={`mobile-nav-${link.label.toLowerCase()}`}
              >
                {link.label}
              </a>
            ))}
            <a
              href={BUY_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-4 bg-[#3A3A3A] text-white flex items-center justify-center gap-3 font-bold uppercase tracking-wider px-6 py-3"
              style={{ fontFamily: 'Oswald, sans-serif' }}
              data-testid="buy-now-mobile-btn"
            >
              <span>Buy at</span>
              <img 
                src={XTREME_LOGO_URL} 
                alt="Xtreme Nutrition" 
                className="h-6 w-auto"
              />
            </a>
          </nav>
        </motion.div>
      )}
    </motion.header>
  );
};

export default Header;
